import * as types from './supplierActionTypes';

const initialState = {
  supplierList: [],
  supplierData: null,
  isLoading: false,
  error: null,
  addSupplierData: null,
  updateSupplierData: null,
  deleteSupplierData: null,
};

export const supplierReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, supplierList: action.payload?.SupplierList 
        || [], error: null };
    case types.GET_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.ADD_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, addSupplierData: action.payload, error: null };
    case types.ADD_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.UPDATE_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.UPDATE_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, updateSupplierData: action.payload, error: null };
    case types.UPDATE_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    case types.DELETE_SUPPLIER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.DELETE_SUPPLIER_SUCCESS:
      return { ...state, isLoading: false, deleteSupplierData: action.payload, error: null };
    case types.DELETE_SUPPLIER_ERROR:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
}; 